/**
 * Template Actions
 * NgRx actions for template management
 */
import { createAction, props } from '@ngrx/store';
import {
  Template,
  CreateTemplateRequest,
  UpdateTemplateRequest,
  CloneTemplateRequest,
  TemplateFilters,
  PaginatedTemplateResponse,
  TemplateTestResponse,
  TemplateListItem,
  EnableTemplateRequest,
  DisableTemplateRequest,
  EnabledTemplatesResponse,
  TemplateSelectionResponse
} from '../models/template.models';

// Load Templates
export const loadTemplates = createAction(
  '[Templates] Load Templates',
  props<{ filters: TemplateFilters }>()
);

export const loadTemplatesSuccess = createAction(
  '[Templates] Load Templates Success',
  props<{ response: PaginatedTemplateResponse }>()
);

export const loadTemplatesFailure = createAction(
  '[Templates] Load Templates Failure',
  props<{ error: string }>()
);

// Load Public Templates
export const loadPublicTemplates = createAction(
  '[Templates] Load Public Templates',
  props<{ filters: TemplateFilters }>()
);

export const loadPublicTemplatesSuccess = createAction(
  '[Templates] Load Public Templates Success',
  props<{ response: PaginatedTemplateResponse }>()
);

export const loadPublicTemplatesFailure = createAction(
  '[Templates] Load Public Templates Failure',
  props<{ error: string }>()
);

// Load Single Template
export const loadTemplate = createAction(
  '[Templates] Load Template',
  props<{ id: string }>()
);

export const loadTemplateSuccess = createAction(
  '[Templates] Load Template Success',
  props<{ template: Template }>()
);

export const loadTemplateFailure = createAction(
  '[Templates] Load Template Failure',
  props<{ error: string }>()
);

// Create Template
export const createTemplate = createAction(
  '[Templates] Create Template',
  props<{ request: CreateTemplateRequest }>()
);

export const createTemplateSuccess = createAction(
  '[Templates] Create Template Success',
  props<{ template: Template }>()
);

export const createTemplateFailure = createAction(
  '[Templates] Create Template Failure',
  props<{ error: string }>()
);

// Update Template
export const updateTemplate = createAction(
  '[Templates] Update Template',
  props<{ id: string; request: UpdateTemplateRequest }>()
);

export const updateTemplateSuccess = createAction(
  '[Templates] Update Template Success',
  props<{ template: Template }>()
);

export const updateTemplateFailure = createAction(
  '[Templates] Update Template Failure',
  props<{ error: string }>()
);

// Delete Template
export const deleteTemplate = createAction(
  '[Templates] Delete Template',
  props<{ id: string }>()
);

export const deleteTemplateSuccess = createAction(
  '[Templates] Delete Template Success',
  props<{ id: string }>()
);

export const deleteTemplateFailure = createAction(
  '[Templates] Delete Template Failure',
  props<{ error: string }>()
);

// Clone Template
export const cloneTemplate = createAction(
  '[Templates] Clone Template',
  props<{ id: string; request: CloneTemplateRequest }>()
);

export const cloneTemplateSuccess = createAction(
  '[Templates] Clone Template Success',
  props<{ template: Template }>()
);

export const cloneTemplateFailure = createAction(
  '[Templates] Clone Template Failure',
  props<{ error: string }>()
);

// Test Template
export const testTemplate = createAction(
  '[Templates] Test Template',
  props<{ id: string; file: File }>()
);

export const testTemplateSuccess = createAction(
  '[Templates] Test Template Success',
  props<{ result: TemplateTestResponse }>()
);

export const testTemplateFailure = createAction(
  '[Templates] Test Template Failure',
  props<{ error: string }>()
);

// Filter Management
export const setFilters = createAction(
  '[Templates] Set Filters',
  props<{ filters: TemplateFilters }>()
);

export const clearFilters = createAction(
  '[Templates] Clear Filters'
);

// UI State
export const selectTemplate = createAction(
  '[Templates] Select Template',
  props<{ template: Template | null }>()
);

export const clearSelectedTemplate = createAction(
  '[Templates] Clear Selected Template'
);

// ============================================================
// Template Selection Actions (for API Usage)
// ============================================================

// Load Enabled Templates
export const loadEnabledTemplates = createAction(
  '[Templates] Load Enabled Templates'
);

export const loadEnabledTemplatesSuccess = createAction(
  '[Templates] Load Enabled Templates Success',
  props<{ response: EnabledTemplatesResponse }>()
);

export const loadEnabledTemplatesFailure = createAction(
  '[Templates] Load Enabled Templates Failure',
  props<{ error: string }>()
);

// Enable Templates
export const enableTemplates = createAction(
  '[Templates] Enable Templates',
  props<{ request: EnableTemplateRequest }>()
);

export const enableTemplatesSuccess = createAction(
  '[Templates] Enable Templates Success',
  props<{ response: TemplateSelectionResponse }>()
);

export const enableTemplatesFailure = createAction(
  '[Templates] Enable Templates Failure',
  props<{ error: string }>()
);

// Disable Templates
export const disableTemplates = createAction(
  '[Templates] Disable Templates',
  props<{ request: DisableTemplateRequest }>()
);

export const disableTemplatesSuccess = createAction(
  '[Templates] Disable Templates Success',
  props<{ response: TemplateSelectionResponse }>()
);

export const disableTemplatesFailure = createAction(
  '[Templates] Disable Templates Failure',
  props<{ error: string }>()
);

